<template>
  <div>
    <title_header :title="headerTitle" />
    <div class="jc-center">
      <div class="content">
        <div class="flex wrap" v-if="list.length != 0">
          <div class="good cp" v-for="(item, index) in list" :key="index">
            <div class="goodItem">
              <img :src="item.logo" />
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="jc-sb">
                  <div class="left">{{ item.lesson }}课时</div>
                  <div class="right">
                    ￥ <span>{{ item.price }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-empty :image-size="200" v-else></el-empty>
        <div class="jc-center">
          <el-pagination
            class="box_pagination"
            background
            layout="prev, pager, next"
            :current-page="pageNumber"
            @current-change="handleCurrentChange"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import title_header from "../../components/title_header";
export default {
  props: { info: Object },
  components: {
    title_header,
  },
  data() {
    return {
      headerTitle: "项目课程",
      list: [],
      pageSize: 10,
      pageNumber: 1,
      total: 0,
    };
  },
  watch: {
    info: {
      handler() {
        this.initData();
      },
      deep: true,
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getList();
    },
    getList() {
      this.api.schoolPage
        .getCourseCenterGoodsPageList({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
        })
        .then((res) => {
          this.list = res.data.records;
          this.total = res.data.total;
        });
    },
    initData() {
      this.pageNumber = 1;
      this.pageSize = this.info.title || 10;
      this.getList();
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.jc-center {
  margin-top: 30px;
}
.content {
  width: 1200px;
}

.title img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}
.title h2 {
  font-size: 24px;
  font-weight: 600;
}
.more {
  color: #8c8c8c;
  font-size: 14px;
}
.good {
  margin-right: 24px;

  &:nth-child(4n + 4) {
    margin-right: 0;
  }
}
.goodItem {
  width: 282px;
  height: 290px;
  margin-top: 8px;
  border-radius: 6px;
  &:hover {
    color: #0a58ca;
    animation: test 0.4s;
    animation-fill-mode: forwards;
  }
  @keyframes test {
    from {
      margin-top: 8px;
      box-shadow: 0 0 0 0 rgb(0 0 0 / 10%);
    }
    to {
      margin-top: 2px;
      box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    }
  }
  img {
    border-radius: 6px 6px 0 0;
    width: 100%;
    height: 210px;
  }
}

.info {
  padding: 10px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-weight: bolder;
  }
  .left {
    color: #8c8c8c;
    font-size: 12px;
  }
  .right {
    color: red;
    span {
      font-size: 20px;
      font-weight: 600px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/goods/goods2/index.vue